import { render, staticRenderFns } from "./ClientPromocodesPage.vue?vue&type=template&id=fbe025a4&scoped=true"
import script from "./ClientPromocodesPage.vue?vue&type=script&lang=js"
export * from "./ClientPromocodesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe025a4",
  null
  
)

export default component.exports